import { render } from "./UploadPopModel.vue?vue&type=template&id=1b773c5c&scoped=true"
import script from "./UploadPopModel.vue?vue&type=script&lang=js"
export * from "./UploadPopModel.vue?vue&type=script&lang=js"

import "./UploadPopModel.vue?vue&type=style&index=0&id=1b773c5c&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b773c5c"]])

export default __exports__